import React, { memo } from 'react';
import { HeaderProps } from 'react-big-calendar';
import { Box } from '@mui/material';
import classes from './style';

const MonthHeader = ({ label }: HeaderProps) =>
  <Box className="month-header-text" sx={classes.monthHeaderText}>{label}</Box>;

export default memo(MonthHeader);
